import React from "react";
import { Link } from "react-router-dom";

class Home extends React.Component {
    render() {
        return (
            <>
                <div className="home-image">
                    &nbsp;
                </div>
                <div className="home-bio-panel">
                    <h2>PETER JOHN SALADINO</h2>
                    <div className="divider"></div>
                    <br />
                    <div>
                        <div>1935 - 2019</div>
                        <p>
                            <strong>Welcome to Watercolors by Peter,</strong>{" "}
                            a website dedicated to the artwork and legacy of Peter J Saladino.
                            A fine man, Dad, Grandpa, Great Grandpa, and most importantly
                            husband to Vincenza Saladino, the love of his life.
                            Peter was an artist who appreciated the beauty in life,
                            nature, our world, and the simplest things.
                        </p>
                    </div>
                    <div>
                        <Link to="/about">
                            <button>
                                <span>Read more</span>
                            </button>
                        </Link>
                    </div>
                </div>
                <div className="panel">
                    <div className="collage">
                        <h3>ARTWORK SAMPLES</h3>
                        <div className="row">
                            <div className="column">
                                <img src="/images/art/watercolor/watermarked/pjs004.webp" alt="" loading="lazy" />
                                <img src="/images/art/watercolor/watermarked/pjs006.webp" alt="" loading="lazy" />
                                <img src="/images/art/watercolor/watermarked/pjs008.webp" alt="" loading="lazy" />
                            </div>
                            <div className="column">
                                <img src="/images/art/watercolor/watermarked/pjs018.webp" alt="" loading="lazy" />
                                <img src="/images/art/watercolor/watermarked/pjs005.webp" alt="" loading="lazy" />
                            </div>
                            <div className="column">
                                <img src="/images/art/watercolor/watermarked/pjs080.webp" alt="" loading="lazy" />
                                <img src="/images/art/watercolor/watermarked/pjs090.webp" alt="" loading="lazy" />
                                <img src="/images/art/watercolor/watermarked/pjs110.webp" alt="" loading="lazy" />
                            </div>
                            <div className="column">
                                <img src="/images/art/watercolor/watermarked/pjs153.webp" alt="" loading="lazy" />
                                <img src="/images/art/watercolor/watermarked/pjs155.webp" alt="" loading="lazy" />
                            </div>
                        </div>
                    </div>
                    <br /><br />
                    <div className="see-more-btn">
                        <Link to="/gallery">
                            <button>
                                <span>See gallery</span>
                            </button>
                        </Link>
                    </div>
                    <br />
                </div>
            </>
        );
    }
}

export default Home;
